import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../../store/hooks";

const selectFileUploadState = (state: RootState) => state?.fileUpload;

export const selectFileUploadLoading = createSelector(
	selectFileUploadState,
	(state) => state?.loading ?? false
);

export const selectFileUploadError = createSelector(
	selectFileUploadState,
	(state) => state?.error ?? null
);

export const selectLastFulfilled = createSelector(
	selectFileUploadState,
	(state) => state?.lastFulfilled ?? null
);

export const selectLastRejected = createSelector(
	selectFileUploadState,
	(state) => state?.lastRejected ?? null
);
